import { createFileRoute } from '@tanstack/react-router'
import Tutors from '@/features/tutors'

export const Route = createFileRoute('/_authenticated/tutors/')({
  component: Tutors,
})
